import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import WealthPartnerTable from "./table"

const WealthPartners = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Wealth Partners"}
            breadcrumbItem={"Wealth Partners"}
          />
          <WealthPartnerTable />
        </Container>
      </div>
    </>
  )
}

export default WealthPartners
